import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  MatDatepickerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatInputModule,
  MatNativeDateModule,
  MatOptionModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlider,
  MatSliderModule,
  MatDialogModule,
  MatIconModule,
  MatSnackBarModule,
} from "@angular/material";

@NgModule({
  imports: [
    CommonModule,
    MatExpansionModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatSliderModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatSnackBarModule,
  ],
  exports: [
    MatExpansionModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatSliderModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatSnackBarModule,
  ],
  declarations: [],
})
export class MaterialModule {}



// WEBPACK FOOTER //
// ./src/app/material/material.module.ts